import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";

function Result() {
  const location = useLocation();
  const { title, message } = location.state;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <img
        className="logo"
        src={`${process.env.PUBLIC_URL}/kantan_seikyu_logo.png`}
        alt={title}
      />

      <h2>{title}</h2>

      <p>{message}</p>
    </>
  );
}

export default Result;
